import createIcon from '../../createIcon';

/**
 * @component @name AlignHorizontalLeft
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCAyMkgyVjJINFYyMlpNMjIgN0g2VjEwSDIyVjdaTTE2IDE0SDZWMTdIMTZWMTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AlignHorizontalLeft = createIcon('AlignHorizontalLeft', [
  ['path', { d: 'M4 22H2V2H4V22ZM22 7H6V10H22V7ZM16 14H6V17H16V14Z', key: 'a06tx0' }],
]);

export default AlignHorizontalLeft;
